/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.orders.requests.modals.tickets.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.validate',
  'acme.common.filter.saleChannel'
])

.controller('OrdersRequestsModalsTicketsController', ['$scope', '$uibModalInstance', '$q', 'SelectedEvents', 'IsTemplate', 'ApiService', 'HelpersService', 'ValidateService', 'OrderRequestId', function($scope, $uibModalInstance, $q, SelectedEvents, IsTemplate, ApiService, HelpersService, ValidateService, OrderRequestId) {

    $scope.ordersRequestsModalsTickets = {

      selectedEvents: [],

      offScheduleEvent: {},

      currentEvent: {},
      currentPrices: [],
      currentAddons: [],

      addedPrices: [],
      addedAddons: [],

      prices: [],
      addons: [],

      selectedTicket: {},
      selectedAddon: {},

      currentEventIndex: -1,

      isSubmitted: false,

      showCapacity: false,

      isSaving: false,

      errors: [],
      messages: [],

      init: function() {
        if (SelectedEvents instanceof Array && SelectedEvents.length) {
          this.selectedEvents = SelectedEvents;
          if (!IsTemplate) {
            this.showCapacity = true;
          }
          this.nextEvent();
        }
      },

      getEventTemplate: function() {
        ApiService.program.get(this.currentEvent.eventTemplateId, true).then(this.success.getEventTemplate, this.error.getEventTemplate);
      },

      getEvent: function() {
        ApiService.program.instances.detail(this.currentEvent.eventId).then(this.success.getEvent, this.error.getEvent);
      },

      getCurrentEventDetails: function() {
        if (IsTemplate) {
          this.getEventTemplate();
        }else {
          this.getEvent();
        }
      },

      showEvent: function(index) {
        this.currentEvent = this.selectedEvents[index];

        if (this.selectedEvents[index].orderRequestItemSummary) {
          this.getAddOnsAndTicketsForEvent(this.selectedEvents[index]);
        } else {
          this.currentAddons = [];
          this.currentPrices = [];
        }

        this.addedAddons = this.currentEvent.addedAddons || [];
        this.addedPrices = this.currentEvent.addedPrices || [];

        this.getCurrentEventDetails();
      },

      getAddOnsAndTicketsForEvent: function(event) {
        var i, ii,
            items = event.orderRequestItemSummary.itemDetails instanceof Array ? event.orderRequestItemSummary.itemDetails : [];
        this.currentAddons = [];
        this.currentPrices = [];
        for (i=0, ii=items.length; i < ii; i++) {
          if (items[i].addon || items[i].isAddon) {
            this.currentAddons.push(items[i]);
          }else {
            this.currentPrices.push(items[i]);
          }
        }
      },

      getTicketsForEvent: function(event) {
        var i, ii,
            items = event.orderRequestItemSummary.itemDetails instanceof Array ? event.orderRequestItemSummary.itemDetails : [],
            prices = [];
        for (i=0, ii=items.length; i < ii; i++) {
          if (!items[i].addon && !items[i].isAddon) {
            prices.push(items[i]);
          }
        }
        return prices;
      },

      getAddOnsForEvent: function(event) {
        var i, ii,
          items = event.orderRequestItemSummary.itemDetails instanceof Array ? event.orderRequestItemSummary.itemDetails : [],
          addOns = [];
        for (i=0, ii=items.length; i < ii; i++) {
          if (items[i].addon || items[i].isAddon) {
            addOns.push(items[i]);
          }
        }
        return addOns;
      },

      previousEvent: function() {
        this.storeCurrentEvent();
        this.currentEventIndex = this.currentEventIndex - 1;
        this.showEvent(this.currentEventIndex);
      },

      nextEvent: function() {
        if (this.currentEventIndex > -1) {
          this.storeCurrentEvent();
        }
        this.currentEventIndex = this.currentEventIndex + 1;
        this.showEvent(this.currentEventIndex);
      },

      getCurrentEventName: function() {
        return this.currentEvent.eventName || this.currentEvent.eventTemplateName;
      },

      getPrices: function(index) {
        var self = $scope.ordersRequestsModalsTickets,
          usedTickets = self.addedPrices.map(function(price) {
            return price && price.personType ? price.personType.id : '';
          }),
          i, ii, found,
          prices = [];
        for (i=0, ii=self.prices.length; i < ii; i++) {
          found = usedTickets.indexOf(self.prices[i].personType.id);
          if (found < 0) {
            prices.push(self.prices[i]);
          }
        }

        if (self.addedPrices[index] && self.addedPrices[index].personType) {
          prices.unshift(self.addedPrices[index]);
        }

        return prices;
      },

      getAddons: function(index) {
        var self = $scope.ordersRequestsModalsTickets,
          usedAddons = self.addedAddons.map(function(addon) {
            return addon && addon.id ? addon.id : '';
          }),
          i, ii, found,
          addons = [];
        for (i=0, ii=self.addons.length; i < ii; i++) {
          found = usedAddons.indexOf(self.addons[i].id);
          if (found < 0) {
            addons.push(self.addons[i]);
          }
        }

        if (self.addedAddons[index] && self.addedAddons[index].id) {
          addons.unshift(self.addedAddons[index]);
        }

        return addons;
      },

      hasAddonsOrPrices: function() {
        return this.hasAddons() || this.hasPrices();
      },

      hasAddons: function() {
        return (this.addons instanceof Array && this.addons.length) || (this.currentAddons instanceof Array && this.currentAddons.length);
      },

      hasPrices: function() {
        return (this.prices instanceof Array && this.prices.length) || (this.currentPrices instanceof Array && this.currentPrices.length);
      },

      addTicket: function(index) {
        if (index !== undefined) {
          //undo delete
          $scope.ordersRequestsModalsTickets.currentPrices[index].deleted = false;
        } else {
          $scope.ordersRequestsModalsTickets.addedPrices.push(null);
        }
      },

      removeTicket: function(index, current) {
        var self = $scope.ordersRequestsModalsTickets;
        if (current) {
          self.currentPrices[index].deleted = true;
        } else {
          self.addedPrices.splice(index, 1);
        }
      },

      restoreTickets: function() {
        var self = $scope.ordersRequestsModalsTickets;
        this.currentPrices = this.getTicketsForEvent(this.currentEvent);
        this.currentPrices.forEach(function(ticket) {
          ticket.deleted = false;
        });
        this.addedPrices = [];
      },

      addAddon: function(index) {
        if (index !== undefined) {
          $scope.ordersRequestsModalsTickets.currentAddons[index].deleted = false;
        } else {
          $scope.ordersRequestsModalsTickets.addedAddons.push({
            quantity: 0
          });
        }
      },

      removeAddon: function(index, current) {
        if (current) {
          $scope.ordersRequestsModalsTickets.currentAddons[index].deleted = true;
        } else {
          $scope.ordersRequestsModalsTickets.addedAddons.splice(index, 1);
        }
      },

      restoreAddons: function() {
        var self = $scope.ordersRequestsModalsTickets;
        this.currentAddons = this.getAddons(this.currentEvent);
        this.currentAddons.forEach(function(addon) {
          addon.deleted = false;
        });
        this.addedAddons = [];
      },

      isValidCapacity: function() {
        var r = true;

        if (this.isSubmitted && this.showCapacity) {
          r = !isNaN(parseInt(this.currentEvent.capacity, 10)) && ValidateService.validate([{
            greater: {
              greater: this.currentEvent.capacity,
              less: 0
            }
          }]);
        }

        return r;
      },

      isValidQuantity: function() {
        var r = true;

        if (this.isSubmitted && this.showCapacity) {
          r = (this.getTotalQuantity() <= this.currentEvent.capacity);
        }

        return r;
      },

      calculatePrice: function(ticket) {
        return this.calculateTotal(ticket, 'ticket');
      },

      calculateAddOnPrice: function(addon) {
        return this.calculateTotal(addon, 'addOn');
      },

      calculateTotal: function(item, type) {
        var r = 0;
        if (item && type && type === 'ticket') {
          if (item.discountedPrice) {
            r = HelpersService.currencyFloatToInteger(item.discountedPrice) * item.quantity;
          } else {
            r = HelpersService.currencyFloatToInteger(item.price) * item.quantity;
          }
        }else if (item && type && type === 'addOn') {
          r = HelpersService.currencyFloatToInteger(item.price) * item.quantity;
        }

        return HelpersService.integerToCurrencyFloat(r);
      },

      getTotalQuantity: function() {
        var i, ii,
            quantity = 0;
        for (i=0, ii=this.currentPrices.length; i < ii; i++) {
          if (!this.currentPrices[i].deleted) {
            quantity += this.currentPrices[i].quantity;
          }
        }
        for (i=0, ii=this.addedPrices.length; i < ii; i++) {
          quantity += this.addedPrices[i].quantity;
        }
        if ( isNaN(parseInt(quantity, 10)) ) {
          quantity = -1;
        }
        return quantity;
      },

      storeCurrentEvent: function() {
        var i, ii;
        this.currentEvent.addedPrices = this.addedPrices;
        this.currentEvent.addedAddons = this.addedAddons;

        if (!this.currentEvent.orderRequestItemSummary) {
          this.currentEvent.orderRequestItemSummary = {};
        }
        this.currentEvent.orderRequestItemSummary.itemDetails = [];

        for (i=0, ii=this.currentPrices.length; i < ii; i++) {
          this.currentEvent.orderRequestItemSummary.itemDetails.push(angular.extend({}, this.currentPrices[i]));
        }
        for (i=0, ii=this.currentAddons.length; i < ii; i++) {
          this.currentEvent.orderRequestItemSummary.itemDetails.push(angular.extend({}, this.currentAddons[i]));
        }
        this.currentEvent.offScheduleEvent = this.offScheduleEvent;
        this.selectedEvents[this.currentEventIndex] = this.currentEvent;
      },

      reset: function() {
        var i, ii;
        if (this.selectedEvents instanceof Array) {
          for (i=0, ii=this.selectedEvents.length; i < ii; i++) {
            this.selectedEvents[i].addedAddons = null;
            delete(this.selectedEvents[i].addedAddons);
            this.selectedEvents[i].addedPrices = null;
            delete(this.selectedEvents[i].addedPrices);
            this.selectedEvents[i].offScheduleEvent = null;
            delete(this.selectedEvents[i].offScheduleEvent);
          }
        }
      },

      saveOrderRequestItems: function() {
        var i, ii,
            j, jj,
            k, kk,
            deleteItems,
            addItems,
            deletePromises = [],
            addPromises = [],
            updatePromises = [],
            tickets,
            addOns;
        for (i=0, ii=this.selectedEvents.length; i < ii; i++) {

          tickets = this.getTicketsForEvent(this.selectedEvents[i]);
          addOns = this.getAddOnsForEvent(this.selectedEvents[i]);

          deleteItems = [];
          addItems = [];

          if (this.selectedEvents[i].orderRequestItemSummary && (tickets instanceof Array)) {
            for (j = 0, jj = tickets.length; j < jj; j++) {
              if (tickets[j].itemTypeId && tickets[j].deleted) {
                //delete existing item
                deleteItems.push(tickets[j].itemTypeId);
              } else if (tickets[j].added) {
                //add new items
                delete(tickets[j].added);
                addItems.push(tickets[j]);
              }
            }
          }
          if (this.selectedEvents[i].orderRequestItemSummary && (addOns instanceof Array)) {
            for (j = 0, jj = addOns.length; j < jj; j++) {
              if (addOns[j].itemTypeId && addOns[j].deleted) {
                //delete existing item
                deleteItems.push(addOns[j].itemTypeId);
              } else if (addOns[j].added) {
                //add new items
                delete(addOns[j].added);
                addItems.push(addOns[j]);
              }
            }
          }

          if (this.selectedEvents[i].eventId && this.selectedEvents[i].offScheduleEvent) {
            updatePromises.push(ApiService.event.updateOffSchedule( angular.extend(this.selectedEvents[i].offScheduleEvent, {capacity: this.selectedEvents[i].capacity}) ) );
          }

          if (deleteItems.length) {
            for (k = 0, kk = deleteItems.length; k < kk; k++) {
              deletePromises.push(ApiService.orders.requests.items.itemDetails.remove(OrderRequestId, this.selectedEvents[i].orderRequestItemId, deleteItems[k]));
            }
          }
          if (addItems.length) {
            addPromises.push(ApiService.orders.requests.items.itemDetails.createBulk(OrderRequestId, this.selectedEvents[i].orderRequestItemId, addItems));
          }
        }

        $q.all(deletePromises.concat(addPromises).concat(updatePromises)).then(this.success.saveOrderRequestItems, this.error.saveOrderRequestItems);
      },

      marshallOrderRequestItems: function() {
        var i, ii;
        for (i=0, ii=this.selectedEvents.length; i < ii; i++) {
          this.marshallOrderRequestItem(i);
        }
      },

      marshallOrderRequestItem: function(index) {
        var i, ii;

        if (!this.selectedEvents[index].orderRequestItemSummary) {
          this.selectedEvents[index].orderRequestItemSummary = {
            itemDetails: []
          };
        } else if(!this.selectedEvents[index].orderRequestItemSummary.itemDetails instanceof Array) {
          this.selectedEvents[index].orderRequestItemSummary.itemDetails = [];
        }

        if (this.selectedEvents[index].addedPrices instanceof Array) {
          for (i=0, ii=this.selectedEvents[index].addedPrices.length; i < ii; i++) {
            //new ticket
            if (this.selectedEvents[index].addedPrices[i] && this.selectedEvents[index].addedPrices[i].personType && this.selectedEvents[index].addedPrices[i].quantity) {
              this.selectedEvents[index].orderRequestItemSummary.itemDetails.push({
                "itemTypeId": this.selectedEvents[index].addedPrices[i].personType.id,
                "itemTypeName": this.selectedEvents[index].addedPrices[i].personType.name,
                "itemTypeDescription": this.selectedEvents[index].addedPrices[i].personType.description,
                "quantity": this.selectedEvents[index].addedPrices[i].quantity,
                "unitPrice": this.selectedEvents[index].addedPrices[i].price,
                "discountedUnitPrice": this.selectedEvents[index].addedPrices[i].discountedPrice,
                "isAddon": false,
                added: true
              });
            }
          }
        }

        if (this.selectedEvents[index].addedAddons instanceof Array) {
          for (i=0, ii=this.selectedEvents[index].addedAddons.length; i < ii; i++) {
            //new addOn
            if (this.selectedEvents[index].addedAddons[i] && this.selectedEvents[index].addedAddons[i].id && this.selectedEvents[index].addedAddons[i].quantity) {
              this.selectedEvents[index].orderRequestItemSummary.itemDetails.push({
                "itemTypeId": this.selectedEvents[index].addedAddons[i].id,
                "itemTypeName": this.selectedEvents[index].addedAddons[i].name,
                "itemTypeDescription": this.selectedEvents[index].addedAddons[i].description,
                "quantity": this.selectedEvents[index].addedAddons[i].quantity,
                "unitPrice": this.selectedEvents[index].addedAddons[i].price,
                "discountedUnitPrice": this.selectedEvents[index].addedAddons[i].price,
                "isAddon": true,
                added: true
              });
            }
          }
        }
      },

      success: {
        getEventTemplate: function(response){
          var self = $scope.ordersRequestsModalsTickets,
              template = response.data.payload;
          self.prices = (template.priceLists instanceof Array && template.priceLists.length && template.priceLists[0].prices) ? template.priceLists[0].prices || [] : [];
          self.addons = (template.addOns && template.addOns.inventoryAddOns) ? template.addOns.inventoryAddOns || [] : [];
        },

        getEvent: function(response){
          var self = $scope.ordersRequestsModalsTickets;
          self.offScheduleEvent = response.data.payload;

          self.currentEvent.capacity = self.currentEvent.capacity || self.offScheduleEvent.capacity || 0;
          self.prices = self.offScheduleEvent.priceList ? self.offScheduleEvent.priceList.prices || [] : [];
          self.addons = self.offScheduleEvent.addOns ? self.offScheduleEvent.addOns.inventoryAddOns || [] : [];
        },

        saveOrderRequestItems: function(response) {
          var self = $scope.ordersRequestsModalsTickets;
          self.isSaving = false;
          self.successClose();
        }
      },

      error: {
        getEventTemplate: function(response){
        },
        getEvent: function(response){
        },
        saveOrderRequestItems: function (response) {
          var self = $scope.ordersRequestsModalsTickets;
          if (response.data.error) {
            self.errors = [{
              message: response.data.error
            }];
          }
          self.isSaving = false;
        }
      },

      done: function() {
        if (this.isSaving) {
          return;
        }
        this.storeCurrentEvent();
        this.isSubmitted = true;
        if (this.isValidCapacity() && this.isValidQuantity()) {
          this.isSaving = true;
          this.marshallOrderRequestItems();
          this.saveOrderRequestItems();
        }
      },

      successClose: function() {
        this.reset();
        $uibModalInstance.close({events: this.selectedEvents});
      },

      cancel: function () {
        this.reset();
        $uibModalInstance.dismiss('cancel');
      }

    };

    $scope.ordersRequestsModalsTickets.init();

}]);